export const Major=[
   { "name" :"A_artsCultureAndHumanities"},
   { "name" :"B_education"},
   { "name" :"C_environmentalQualityProtectionAndBeautification"},
   { "name" :"D_animalRelated"},
   { "name" :"E_healthGeneralAndRehabilitative"},
   { "name" :"F_mentalHealthCrisisIntervention"},
   { "name" :"G_diseasesDisordersMedicalDisciplines"},
   { "name" :"H_medicalResearch"},
   { "name" :"I_crimeLegalRelated"},
   { "name" :"J_employmentJobRelated"},
   { "name" :"K_foodAgricultureAndNutrition"},
   { "name" :"L_housingShelter"},
   { "name" :"M_publicSafetyDisasterPreparednessAndRelief"},
   { "name" :"N_recreationSportsLeisureAthletics"},
   { "name" :"O_youthDevelopment"},
   { "name" :"P_humanServicesMultipurpose"},
   { "name" :"Q_internationalForeignAffairsAndNationalSecurity"},
   { "name" :"R_civilRightsSocialActionAdvocacy"},
   { "name" :"S_communityImprovementCapacityBuilding"},
   { "name" :"T_philanthropyVoluntarismAndGrantmakingFoundations"},
   { "name" :"U_scienceAndTechnologyResearchInstitutesServices"},
   { "name" :"V_socialScienceResearchInstitutesServices"},
   { "name" :"W_publicSocietyBenefitMultipurpose"},
   { "name" :"X_religionRelatedSpiritualDevelopment"},
   { "name" :"Y_mutualMembershipBenefitOrganizations"},
   { "name" :"Z_unknown"}
]